/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import * as CSS from 'csstype';

type Props = {
  background: string;
  titleColor: CSS.Property.Color;
  mandatorySignColor: CSS.Property.Color;
  cancelButtonColor: CSS.Property.Color;
};

export default (props: EXOThemeProps): Props => {
  return {
    // Default theme
    background: props.theme.colors.backgrounds.panels.secondary.base,
    titleColor: props.theme.colors.link.base,
    mandatorySignColor: '#B91493',
    cancelButtonColor: '#473f4a'
  };
};
